<script>

    export default {
        data () {
            return {

            }
        },
        mounted () {
        },
        props: [
        ],
        methods: {
            show (modalName) {
                this.$modal.show(modalName);
            },
            hide () {
                this.$modal.hide(modalName);
            }
        }
    }
</script>
